import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "./Logo";

export const LegalLayout = ({ eyebrow, title, children, testId }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      data-testid={testId}
      className="min-h-screen bg-[#FAFAF7] text-[#1A1A1F]"
    >
      <header className="border-b border-[#1A1A1F]/[0.08] bg-[#FAFAF7]/80 backdrop-blur-xl sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" data-testid="legal-logo-link">
            <Logo height={26} />
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 text-sm text-[#5A5F66] hover:text-[#1A1A1F] transition-colors"
          >
            <ArrowLeft size={16} />
            Zurück zur Startseite
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 sm:px-8 py-20 sm:py-28">
        <div className="text-xs font-semibold uppercase tracking-[0.25em] text-[#3FA66D] mb-5">
          {eyebrow}
        </div>
        <h1 className="text-5xl sm:text-6xl font-medium tracking-tight leading-[1.05] text-gradient-dark">
          {title}
        </h1>

        <div className="mt-12 space-y-10 text-[#1A1A1F]/85 leading-relaxed legal-body">
          {children}
        </div>

        <div className="mt-16 pt-8 border-t border-[#1A1A1F]/[0.08] text-xs text-[#5A5F66]">
          © {new Date().getFullYear()} pflege-box-gratis.de · Alle Rechte
          vorbehalten
        </div>
      </main>
    </div>
  );
};

export const LegalSection = ({ title, children, testId }) => (
  <section data-testid={testId}>
    <h2 className="text-2xl font-medium text-[#1A1A1F] mb-4">{title}</h2>
    <div className="text-base text-[#1A1A1F]/85 space-y-3">{children}</div>
  </section>
);

export default LegalLayout;
